
import { defineComponent } from 'vue';
import omegaup_OverlayPopup from '../OverlayPopup.vue';
import T from '../../lang';
import * as ui from '../../ui';

export enum AvailableViews {
  Content,
  Question,
  Thanks,
}

export default defineComponent({
  name: 'QualityNominationDemotionPopup',
  components: {
    'omegaup-overlay-popup': omegaup_OverlayPopup,
  },
  emits: ['dismiss', 'submit'],
  data() {
    return {
      AvailableViews,
      T,
      ui,
      rationale: '',
      original: '',
      currentView: AvailableViews.Question,
      selectedReason: '',
    };
  },
  methods: {
    onHide(): void {
      this.$emit('dismiss');
    },
    onSubmit(): void {
      this.$emit('submit', this);
      this.currentView = AvailableViews.Thanks;
      setTimeout(() => this.onHide(), 2000);
    },
  },
});
